import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FrameComponent } from '@evc/web-components';

@Component({
  selector: 'app-public-home',
  standalone: true,
  imports: [FrameComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
}
